function getSquareCenter(square) {
    const {
        transformation: {
            translation: { x, y },
        },
        compiled: {
            polygon: {
                dimensions: { width, height },
            },
        },
    } = square;

    return {
        x: x + width / 2,
        y: y + height / 2,
    };
}

export default getSquareCenter;
